/* default style for component */
import "@fontsource/quicksand";

export const style = {
  cardBox: {
    height: { xs: " 64vh", sm: "78.8vh", md: "77vh" },
    overflowY: { xs: "auto", md: "hidden" },
    marginTop: {md: "-10%"}
  },

  cardChildBox: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "1fr", md: "1fr 1fr 1fr" },
    gap: { xs: "1rem", md: "2rem" },
    marginTop: { xs: "3rem", sm: "5rem" },
  },

  cardsBtn: {
    "&: hover": {
      backgroundColor: "initial",
    },
    width: "100%",
    maxWidth: "250px",
    display: "block",
    margin: "auto",
  },

  cards: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "2px 2px 6px #6D563F1F",
    borderRadius: "10px",
    opacity: 0.6,
    cursor: "pointer",
    marginBottom: { xs: "1rem", sm: "1rem", md: "2rem" },
    border: "1px solid white",
    "&: hover": {
      border: "1px solid #FD7E00",
    },
  },
  cardsContentFirstColumn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: { xs: "35px", sm: "30px", md: "110px" },
    textAlign: "center",
    font: {
      xs: "normal normal 800 15px Quicksand",
      md: "normal normal 800 20px Quicksand",
    },
    letterSpacing: "0px",
    color: "#393939",
    opacity: 1,
    textTransform: "none",
  },

  cardsContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: { xs: "35px", sm: "30px", md: "110px" },
    textAlign: "center",
    font: {
      xs: "normal normal 800 15px Quicksand",
      md: "normal normal 800 20px Quicksand",
    },
    letterSpacing: "0px",
    color: "#393939",
    opacity: 1,
    textTransform: "none",
  },

  iconTextBox: {
    display: { xs: "flex", sm: "flex", md: "block" },
    textAlign: "center",
    gap: { xs: 1 },
    justifyContent: { xs: "center" },
    marginBottom: "1rem",
  },

  bulbIcon: {
    height: { xs: "30px", sm: "40px", md: "70px" },
    width: { xs: "30px", sm: "40px", md: "70px" },
  },

  examplesText: {
    fontSize: { xs: "20px", sm: "25px", md: "28px" },
    fontFamily: "Quicksand",
    fontWeight: 800,
    letterSpacing: "0px",
    color: "#3C3C3C",
    opacity: 1,
  },
};
